import { render, staticRenderFns } from "./change-password-modal.vue?vue&type=template&id=54d12b96&"
import script from "./change-password-modal.vue?vue&type=script&lang=js&"
export * from "./change-password-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports